import React from 'react';
import { Typography } from 'antd';
import LocationSimulator from '../components/LocationSimulator';

const { Title } = Typography;

const LocationSimulatorView: React.FC = () => {
  return (
    <div className="space-y-6 p-6">
      <LocationSimulator />
    </div>
  );
};

export default LocationSimulatorView;
